import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import pathfinder from '@fiverr-private/pathfinder';
import { LOGGED_OUT_HEADER_TYPE } from './constants';

export const DEFAULT_BLOG_URL = 'http://blog.fiverr.com';
const GERMAN_SUFFIX = 'de';

export const BLOG_PAGE_URLS = {
    [SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE]: `${DEFAULT_BLOG_URL}/${GERMAN_SUFFIX}`,
};

export const getLinks = (headerType) => {
    const { locale } = getContext();
    const blogUrl = BLOG_PAGE_URLS[locale] || DEFAULT_BLOG_URL;
    const isLoggedOutHeader = headerType === LOGGED_OUT_HEADER_TYPE;

    return [
        {
            key: isLoggedOutHeader ? 'fiverr_go_full' : 'fiverr_go',
            linkUrl: pathfinder('seller_ai_hub_page'),
            isNew: isLoggedOutHeader,
        },
        {
            key: 'answers',
            linkUrl: 'https://answers.fiverr.com',
            withoutSource: true,
            isNew: false,
        },
        {
            key: 'community',
            linkUrl: 'https://events.fiverr.com/',
            isNew: false,
        },
        {
            key: 'guides',
            linkUrl: '/resources/guides', // pathfinder issue https://github.com/fiverr/pathfinder/issues/45
            isNew: false,
        },
        {
            key: 'podcast',
            linkUrl: 'https://play.acast.com/s/ninetwentynine',
            nofollow: true,
            isNew: false,
        },
        {
            key: 'learn',
            linkUrl: 'https://learn.fiverr.com/',
            isNew: false,
        },
        {
            key: 'blog',
            linkUrl: blogUrl,
            isNew: false,
        },
        {
            key: 'logo_maker',
            linkUrl: 'https://www.fiverr.com/logo-maker',
            isNew: false,
        },
    ];
};
